/*
 * Copyright (c) 2022 EGT Digital - All rights reserved.
 *
 * File: Search.tsx
 *
 * Written by Martin Lubenov <martin.lubenov@egt-digital.com> on  27.10.22 2:06 pm.
 * Last modified: 27.10.22 2:06 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { addBuildHash } from '../api/helpers';
import { useLobbyHost } from '../contexts/SettingsContext';

const Search = ({ active, onClick, className }: ISearchProps) => {
    const host = useLobbyHost();
    return (
        <div className={`egt_lobby_search_button ${active ? 'active' : ''} ${className || ''}`}>
            <img
                src={addBuildHash(`${host}/assets/portal/ui/srch.svg`)}
                alt="egt_lobby_search_button-icon"
                className="tab"
                onClick={onClick}
            />
        </div>
    );
};

interface ISearchProps {
    active?: boolean;
    onClick?: () => void;
    className?: string;
}

export default Search;
